class MobileNavToggle extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector('[data-mobile-nav-toggle]');
    this.toggleButton.addEventListener('click', this.toggleNav.bind(this));
  }

  toggleNav(event) {
    const mobileNav = document.querySelector('mobile-nav');

    if (event.target.hasAttribute('data-mobile-nav-screenreader-close')) {
      const mobileNavToggles = document.querySelectorAll('mobile-nav-toggle');

      removeTrapFocus();

      document.body.classList.remove('scroll-lock');
      mobileNav.classList.remove('active');

      mobileNavToggles.forEach((mobileNavToggle, index) => {
        if (index === 0) {
          mobileNavToggle.querySelector('[data-mobile-nav-toggle]').focus();
        }

        mobileNavToggle.classList.remove('active');
      });
    } else {
      mobileNav.classList.toggle('active');
      this.classList.toggle('active');

      if (this.classList.contains('active')) {
        trapFocus(mobileNav);
        document.body.classList.add('scroll-lock');
      } else {
        removeTrapFocus();
        document.body.classList.remove('scroll-lock');
      }
    }
  }
}

customElements.define('mobile-nav-toggle', MobileNavToggle);

class MobileNav extends HTMLElement {
  constructor() {
    super();
    this.submenuToggleButtons = this.querySelectorAll('[data-mobile-nav-submenu-toggle]');
    this.submenuLinkWrappers = this.querySelectorAll('[data-mobile-nav-submenu-link-wrapper]');
    this.backButtons = this.querySelectorAll('[data-mobile-nav-back]');
    this.submenuToggleButtons.forEach((submenuToggleButton) => submenuToggleButton.addEventListener('click', this.openSubmenu.bind(this)));
    this.backButtons.forEach((backButton) => backButton.addEventListener('click', this.goBack.bind(this)));
    this.setHeaderHeight();
    window.addEventListener('resize', () => this.setHeaderHeight());
  }

  openSubmenu(event) {
    const linkWrapper = event.currentTarget.closest('[data-mobile-nav-submenu-link-wrapper]');
    linkWrapper.classList.add('submenu-active');
    this.classList.add('submenu-active');
    trapFocus(linkWrapper);
  }

  goBack() {
    this.submenuLinkWrappers.forEach((submenuLinkWrapper) => submenuLinkWrapper.classList.remove('submenu-active'));
    this.classList.remove('submenu-active');
    removeTrapFocus();
  }

  setHeaderHeight() {
    const header = document.querySelector('[data-header]');
    const announcementBar = document.querySelector('[data-header-announcement-bar]');
    const headerHeight = header.offsetHeight + announcementBar.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  }
}

customElements.define('mobile-nav', MobileNav);
